import clsx from 'clsx'

import { BadgeProps } from './Badge.types'

export const Badge = (props: BadgeProps) => {
  const {
    children,
    className,
    color = 'teal',
    rounded,
    variant = 'primary',
  } = props

  const classNames = clsx(
    'Badge',
    `Badge-${variant}`,
    `Badge-${variant}-${color}`,
    rounded && `Badge-rounded`,
    className,
  )

  return (
    <span className={classNames} role="status">
      {children}
    </span>
  )
}
